module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-29.a264587e.png";